/**
 * @generated SignedSource<<315c7deaff8ad77848ebbecd868f67f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeFundServiceSection_pageSection$data = {
  readonly anchorName: string;
  readonly autocomplete: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly country: string | null | undefined;
          readonly fundsname: string | null | undefined;
          readonly largeinvestmentfonds: number | null | undefined;
          readonly tranches: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly isin: string | null | undefined;
                readonly salesadmission: ReadonlyArray<string | null | undefined> | null | undefined;
                readonly url: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"FundsserviceAutocomplete_autocomplete">;
  } | null | undefined;
  readonly fundsListUrl: string | null | undefined;
  readonly placeholder: string | null | undefined;
  readonly show: string | null | undefined;
  readonly showAll: string | null | undefined;
  readonly text: string | null | undefined;
  readonly title: string;
  readonly titleImageBackgroundUrl: string;
  readonly titleImageUrl: string;
  readonly " $fragmentType": "HomeFundServiceSection_pageSection";
};
export type HomeFundServiceSection_pageSection$key = {
  readonly " $data"?: HomeFundServiceSection_pageSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeFundServiceSection_pageSection">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeFundServiceSection_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageBackgroundUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anchorName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fundsListUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placeholder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showAll",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "show",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HomeFundServiceAutocomplete",
      "kind": "LinkedField",
      "name": "autocomplete",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "FundsConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FundsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Funds",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "country",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fundsname",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "largeinvestmentfonds",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": (v0/*: any*/),
                      "concreteType": "TrancheConnection",
                      "kind": "LinkedField",
                      "name": "tranches",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TrancheEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Tranche",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "url",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isin",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "salesadmission",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "tranches(first:1000)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:1000)"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FundsserviceAutocomplete_autocomplete"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomeFundService",
  "abstractKey": null
};
})();

(node as any).hash = "d7b5f8b99d162fb3e7ce380c440069c4";

export default node;
